// 디자인 외주 공용 상수·헬퍼 (#38 외주 의뢰서 자동 작성, 2026-08-18)
// 받는 파일 고정 문구는 발주 작성 화면·수주 받은 의뢰 상세·수락 확인창 3곳에 "같은 문구"로 보여야 한다(기획서 3-4절).
// 문구를 한 곳에 두어 세 화면이 어긋나는 것을 원천 차단한다. 수수료 관련 문구는 어디에도 넣지 않는다(08-17 수수료 폐지).

// ── 받는 파일 고정 규칙 (v4 대표 확정 — 선택 UI 없음) ──
export const DELIVERABLE_RULE_TEXT = '받는 파일: 디자인 완성 STL + CAD 원본 프로젝트 파일 [↔ 왕복]';
export const DELIVERABLE_RULE_SUB = '원본은 주고받으며 수정할 수 있습니다 (v1, v2…)';
// [전달 완료] 확인창 리마인드 — 차단 아님(파일 종류를 시스템이 판별할 수 없음, 기획서 2절)
export const DELIVER_REMIND_TEXT = 'STL과 CAD 원본을 함께 담았는지 확인하세요.';

// ── 의뢰 폼 공통 상수 (DesignOutsource 모달에서 전용 페이지로 이관, 2026-08-18) ──
export const PROSTHESIS_TYPES = ['크라운', '브릿지', '임플란트 크라운', '커스텀 어버트먼트', '인레이·온레이', '덴처', '파샬 프레임', '서지컬 가이드', '교정장치', '기타'];

export function newCaseNo() {
    const d = new Date();
    const ymd = `${String(d.getFullYear()).slice(2)}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
    return `DO-${ymd}-${Math.random().toString(36).slice(2, 5).toUpperCase()}`;
}

// 이름 마스킹: 앞 1글자 + '**' (2글자 이하도 첫 글자만 노출). 개인정보방침 — 외주 명세서·파일명 환자 실명 노출 금지
export function maskName(name) {
    const n = (name || '').trim();
    if (!n) return '';
    return n[0] + '**';
}

// 가운데 O 마스킹(김O수) — 외주 의뢰 문서에는 실명 대신 이것만 저장한다 (대표 확정 2026-08-22).
// 근거: 의뢰 문서는 수주랩이 통째로 읽을 수 있어(firestore.rules) 표시만 가려도 실명이 데이터로 넘어감 —
// 약관 제4조의7 제3항(설계에 필요한 범위로 최소화)·최소수집 원칙에 맞춰 저장 시점부터 마스킹(법적보안 검토 08-22).
// 2글자는 첫 글자+O, 1글자는 O(전부 가림).
export function maskNameMiddle(name) {
    // 10-13 보안 점검: 글자 단위(코드 포인트)로 — 4바이트 한자(𠀀 등)를 반쪽으로 잘라 깨진 문자열이 저장·rules 거부되지 않게
    const n = Array.from((name || '').trim());
    if (!n.length) return '';
    if (n.length === 1) return 'O';
    if (n.length === 2) return n[0] + 'O';
    return n[0] + 'O'.repeat(n.length - 2) + n[n.length - 1];
}

// 파일명에 환자 실명이 그대로 들어가면 마스킹명으로 치환 (외주 첨부·출처 표기에 한함)
export function maskPatientInFileName(fileName, patientName) {
    const fn = String(fileName || '');
    const pn = (patientName || '').trim();
    if (!fn || !pn) return fn;
    // 외자 이름(1글자)도 치환 — 종전 pn.length<2 예외로 실명 잔존 가능했음 (검수 P2-3, 2026-08-18)
    return fn.split(pn).join(maskName(pn));
}

// CAD 보철명 → 의뢰서 보철 종류 (DesignOutsource CAD 불러오기 typeMap 재사용 + 한글 키워드 확장, 기획서 3-6절)
const TYPE_MAP = { Crown: '크라운', Pontic: '브릿지', Bridge: '브릿지', Abutment: '커스텀 어버트먼트', Inlay: '인레이·온레이', Onlay: '인레이·온레이', Coping: '크라운', Veneer: '기타' };
export function mapProsthesisType(name) {
    const n = String(name || '').trim();
    if (!n) return '';
    if (PROSTHESIS_TYPES.includes(n)) return n;
    const low = n.toLowerCase();
    for (const k of Object.keys(TYPE_MAP)) {
        if (low.includes(k.toLowerCase())) return TYPE_MAP[k];
    }
    if (n.includes('임플') && n.includes('크라운')) return '임플란트 크라운';
    if (n.includes('브릿지') || n.includes('브리지')) return '브릿지';
    if (n.includes('어버트')) return '커스텀 어버트먼트';
    if (n.includes('크라운')) return '크라운';
    if (n.includes('인레이') || n.includes('온레이')) return '인레이·온레이';
    if (n.includes('덴처') || n.includes('틀니')) return '덴처';
    return '기타';
}

// 치아별 요약 한 줄 — CAD 불러오기 요약 문법(:1206) 재사용. 치과명·환자명은 넣지 않는다(기획서 3-6절)
export function buildTeethSummary(teethDetails) {
    return (teethDetails || [])
        .map(d => `#${d.tooth} ${d.prosthesis || ''}${d.material ? `(${d.material})` : ''}${d.shade ? ` ${d.shade}` : ''}`.trim())
        .join(', ');
}

// ── 원본 왕복 버전 표기 (v4 — 웹 폴백, 기획서 3-5절) ──
// vN = 수주랩의 N번째 전달본 / 수정 요청 N = 발주랩의 N번째 수정본.
// 신규 최상위 필드 없이 files[] 항목의 kind('delivery'|'revision'|'source')·rev만으로 계산한다(rules 무변경).
export function maxRevisionRev(files) {
    return (files || []).reduce((m, f) => (f?.kind === 'revision' && (f.rev || 0) > m ? f.rev : m), 0);
}
export function latestDeliveryRev(files) {
    return (files || []).reduce((m, f) => (f?.kind === 'delivery' && (f.rev || 0) > m ? f.rev : m), 0);
}
// 파일 칩 버전 라벨 — 라벨 없는 옛 파일은 빈 문자열(그대로 표시)
export function fileVersionLabel(f) {
    if (!f || !f.kind || !f.rev) return '';
    if (f.kind === 'delivery') return `v${f.rev}`;
    if (f.kind === 'revision') return `수정 요청 ${f.rev}`;
    return '';
}
